<div class="profile">
    <div class="profile__account">
        <div class="profile__prefix">
            <ng-container *ngIf="userProfile">
                <span [title]="fullName">{{ fullName | initials }}</span>
            </ng-container>
        </div>
        <div class="profile__username">
            <ng-container *ngIf="userProfile">
                <span class="name" [title]="fullName">{{ fullName }}</span>
                <span class="role">{{ userProfile.description }}</span>
            </ng-container>
        </div>
    </div>
    <div class="profile__options">
        <ul>
            <li><a class="profile__link" href="#">Profile Management</a></li>
            <li><a class="profile__link txt-red" href="#" (click)="logout()">Log Out</a></li>
        </ul>
    </div>
</div>
